<template>
  <div class="publicSubmit forgetPassword">
    <app-header :disablejump="true"></app-header>
    <div class="login-container">
      <div class="container clearfix">
        <div class="loginBox">
          <el-form
            v-if="!next"
            autocomplete="on"
            :model="loginForm"
            :rules="loginRules"
            ref="loginForm"
            label-position="left"
          >
            <div class="loginForm">
              <div class="head">
                <a @click="handleRegister" class="active">找回密码</a>
              </div>
              <div class="content">
                <div id="login">
                  <div class="form-group">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text">
                        <use xlink:href="#icon-mobile">
                          <svg id="icon-mobile" viewBox="0 0 1024 1024" width="100%" height="100%">
                            <path
                              d="M724.739821 95.91041H294.226759c-32.749996 0-59.380229 26.62921-59.38023 59.380229V867.868751c0 32.75102 26.630233 59.380229 59.38023 59.380229H724.739821c32.755115 0 59.385349-26.62921 59.385349-59.380229V155.290639c0-32.75102-26.630233-59.380229-59.385349-59.380229z m-7.421121 764.531077h-415.666725V162.715856h415.667749v697.725631z m0 0"
                            />
                            <path
                              d="M472.372566 765.806838c0 20.495113 16.613563 37.113795 37.113796 37.113795 20.496136 0 37.112771-16.618683 37.112771-37.113795 0-20.499208-16.616635-37.112771-37.112771-37.112772-20.501256 0-37.113795 16.612539-37.113796 37.112772z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>

                      <el-form-item prop="phone_nbr">
                        <input
                          name="phone_nbr"
                          type="text"
                          v-model="loginForm.phone_nbr"
                          autocomplete="on"
                          placeholder="请输入手机号"
                          class="form-control ui-input"
                        />
                      </el-form-item>
                    </div>
                    <div class="help-block"></div>
                  </div>
                  <div class="form-group" v-if="isVerification&&isVerification.length>0&&isVerification[0].value==='true'">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text">
                        <use xlink:href="#icon-code">
                          <svg id="icon-code" viewBox="0 0 1024 1024" width="100%" height="100%">
                            <path
                              d="M510.109908 96.208361L132.2481 248.881949v229.008335c0 189.981922 129.689411 368.919193 312.731438 438.498344 41.485786 15.769882 88.771882 15.769882 130.263811 0 183.041003-69.579151 312.725295-248.516422 312.725295-438.498344V248.881949L510.109908 96.208361z m311.915401 387.671652c0 156.828515-107.054378 304.540355-258.150159 361.972132-34.251012 13.023821-73.284592 13.023821-107.535604 0-151.095781-57.437919-258.151183-205.143616-258.151183-361.972132V294.833923L510.109908 168.811045l311.915401 126.022878v189.04609z m-358.259523 90.585183L677.341098 360.902171l44.523653 44.524677-258.098965 258.091798-130.173708-130.170637 44.522629-44.523653 85.651079 85.64084z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>

                      <el-form-item prop="vcode">
                        <div style="display:flex;">
                          <input
                            name="vcode"
                            type="text"
                            v-model="loginForm.vcode"
                            autocomplete="on"
                            placeholder="请输入短信验证码"
                            class="form-control ui-input"
                          />
                          <!-- @click="dialogVisible = true" -->
                          <span class="input-group-append">
                            <button
                              type="button"
                              class="btn btn-boot"
                              @click="handleVerification"
                            >{{content}}</button>
                          </span>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="help-block"></div>
                  </div>

                  <el-form-item style="margin: 30px auto">
                    <el-button
                      style="width: 100%"
                      type="primary"
                      :loading="loading"
                      @click.native.prevent="handleRetrievePassword"
                    >下一步</el-button>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>

          <el-form
            autocomplete="on"
            :model="forgetForm"
            :rules="forgetRules"
            ref="forgetForm"
            label-position="left"
            v-if="next"
          >
            <div class="loginForm">
              <div class="head">
                <a @click="handleRegister" class="active">找回密码</a>
              </div>
              <div class="content">
                <div id="login">
                  <div class="form-group">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text">
                        <use xlink:href="#icon-pass">
                          <svg id="icon-pass" viewBox="0 0 1024 1024" width="100%" height="100%">
                            <path
                              d="M611.139744 96.566721c-174.373814 0-315.720159 141.346345-315.720159 315.720159 0 73.013263 24.823076 140.204713 66.365175 193.689411l-42.683731 42.687827-64.702386-64.701362c-3.220119-3.220119-8.518726-3.220119-11.841233 0l-41.333227 41.334251c-3.221143 3.221143-3.221143 8.513606 0 11.836114l64.700337 64.701362-46.631833 46.633881-64.702385-64.701362c-3.221143-3.220119-8.51463-3.220119-11.835091 0l-41.33425 41.334251c-3.221143 3.221143-3.221143 8.515654 0 11.841233l64.701361 64.701362-67.822164 67.814997c-3.220119 3.220119-3.220119 8.518726 0 11.734749l43.931848 43.9298c3.221143 3.221143 8.51975 3.221143 11.733726 0L417.348969 661.748348c53.586062 41.441759 120.783656 66.258691 193.791799 66.258691 174.374838 0 315.725279-141.345321 315.725279-315.720159 0-174.373814-141.351465-315.720159-315.726303-315.720159z m167.417538 483.136672c-44.655735 44.764266-104.164974 69.37847-167.417538 69.37847-63.24642 0-122.755659-24.614203-167.411394-69.37847-44.762219-44.654711-69.377446-104.164974-69.377445-167.416513 0-63.24642 24.615227-122.755659 69.377445-167.416513 44.655735-44.757099 104.164974-69.371302 167.411394-69.371303 63.25154 0 122.760779 24.615227 167.417538 69.371303 44.762219 44.661878 69.377446 104.170093 69.377445 167.416513 0 63.25154-24.615227 122.761803-69.377445 167.416513z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>
                      <el-form-item prop="password">
                        <input
                          type="password"
                          id="password"
                          maxlength="16"
                          @keyup.enter.native="handleModifyPassword"
                          v-model="forgetForm.password"
                          autocomplete="on"
                          placeholder="请输入密码"
                          class="form-control ui-input"
                        />
                      </el-form-item>
                    </div>
                    <div class="help-block"></div>
                  </div>

                  <div class="form-group">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text">
                        <use xlink:href="#icon-pass">
                          <svg id="icon-pass" viewBox="0 0 1024 1024" width="100%" height="100%">
                            <path
                              d="M611.139744 96.566721c-174.373814 0-315.720159 141.346345-315.720159 315.720159 0 73.013263 24.823076 140.204713 66.365175 193.689411l-42.683731 42.687827-64.702386-64.701362c-3.220119-3.220119-8.518726-3.220119-11.841233 0l-41.333227 41.334251c-3.221143 3.221143-3.221143 8.513606 0 11.836114l64.700337 64.701362-46.631833 46.633881-64.702385-64.701362c-3.221143-3.220119-8.51463-3.220119-11.835091 0l-41.33425 41.334251c-3.221143 3.221143-3.221143 8.515654 0 11.841233l64.701361 64.701362-67.822164 67.814997c-3.220119 3.220119-3.220119 8.518726 0 11.734749l43.931848 43.9298c3.221143 3.221143 8.51975 3.221143 11.733726 0L417.348969 661.748348c53.586062 41.441759 120.783656 66.258691 193.791799 66.258691 174.374838 0 315.725279-141.345321 315.725279-315.720159 0-174.373814-141.351465-315.720159-315.726303-315.720159z m167.417538 483.136672c-44.655735 44.764266-104.164974 69.37847-167.417538 69.37847-63.24642 0-122.755659-24.614203-167.411394-69.37847-44.762219-44.654711-69.377446-104.164974-69.377445-167.416513 0-63.24642 24.615227-122.755659 69.377445-167.416513 44.655735-44.757099 104.164974-69.371302 167.411394-69.371303 63.25154 0 122.760779 24.615227 167.417538 69.371303 44.762219 44.661878 69.377446 104.170093 69.377445 167.416513 0 63.25154-24.615227 122.761803-69.377445 167.416513z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>
                      <el-form-item prop="password_confirmation">
                        <input
                          type="password"
                          id="password_confirmation"
                          maxlength="16"
                          @keyup.enter.native="handleModifyPassword"
                          v-model="forgetForm.password_confirmation"
                          autocomplete="on"
                          placeholder="请再次输入密码"
                          class="form-control ui-input"
                        />
                      </el-form-item>
                    </div>
                    <div class="help-block"></div>
                  </div>

                  <el-form-item style="margin: 30px auto">
                    <el-button
                      style="width: 100%"
                      type="primary"
                      :loading="loading"
                      @click.native.prevent="handleModifyPassword"
                    >修改密码</el-button>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>

          <el-dialog class="detectionCode" title="请输入验证码" :visible.sync="dialogVisible">
            <el-form
              autocomplete="on"
              ref="numberValidateForm"
              label-position="left"
              :model="loginForm"
              @submit.native.prevent
            >
              <div class="loginForm">
                <div id="login">
                  <div class="form-group">
                    <div class="input-group">
                      <svg aria-hidden="true" class="icon input-group-text" style="margin:0 10px;">
                        <use xlink:href="#icon-code">
                          <svg id="icon-code" viewBox="0 0 1024 1024" width="100%" height="100%">
                            <path
                              d="M510.109908 96.208361L132.2481 248.881949v229.008335c0 189.981922 129.689411 368.919193 312.731438 438.498344 41.485786 15.769882 88.771882 15.769882 130.263811 0 183.041003-69.579151 312.725295-248.516422 312.725295-438.498344V248.881949L510.109908 96.208361z m311.915401 387.671652c0 156.828515-107.054378 304.540355-258.150159 361.972132-34.251012 13.023821-73.284592 13.023821-107.535604 0-151.095781-57.437919-258.151183-205.143616-258.151183-361.972132V294.833923L510.109908 168.811045l311.915401 126.022878v189.04609z m-358.259523 90.585183L677.341098 360.902171l44.523653 44.524677-258.098965 258.091798-130.173708-130.170637 44.522629-44.523653 85.651079 85.64084z m0 0"
                            />
                          </svg>
                        </use>
                      </svg>
                      <el-form-item
                        prop="captcha_value"
                        :rules="[{ required: true, message: '验证码不能为空'}]"
                      >
                        <input
                          type="text"
                          id="captcha_value"
                          v-model="loginForm.captcha_value"
                          autocomplete="on"
                          placeholder="请输入验证码"
                          class="form-control ui-input"
                        />
                      </el-form-item>

                      <div class="input-group-append" @click="handleImgSrc">
                        <img width="88" height="38" :src="imgsrc" alt class="verification-img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cen">
                <span slot="footer" class="dialog-footer cen">
                  <el-button type="primary" @click="handleCaptcha_value" :loading="loading">发送验证码</el-button>
                </span>
              </div>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isvalidUsername, validatPhone } from '@/utils/validate';
import { setSupport, SupportUrl } from '@/utils/support';

export default {
  name: 'Login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 8) {
        callback(new Error('密码不能小于8位'));
      } else if (
        this.forgetForm.password !== this.forgetForm.password_confirmation
      ) {
        callback(new Error('两次密码输入不同'));
      } else {
        callback();
      }
    };

    const validatePhone = (rule, value, callback) => {
      if (!validatPhone(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    const validateVcode = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error('请输入正确验证码'));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        phone_nbr: '',
        vcode: '',

        captcha_value: '',
        captcha_id: ''
      },

      forgetForm: {
        password: '',
        password_confirmation: ''
      },
      forgetRules: {
        password: [
          { required: true, trigger: 'blur', validator: validatePass }
        ],
        password_confirmation: [
          { required: true, trigger: 'blur', validator: validatePass }
        ]
      },
      loginRules: {
        phone_nbr: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        vcode: [{ required: true, trigger: 'blur', validator: validateVcode }]
      },
      next: false,
      loading: false,
      pwdType: 'password',
      dialogVisible: false,
      content: '发送验证码',
      disabled: true,
      redirect: '/manage',
      totalTime: 60,
      sending: true, // 是否发送验证码
      isVerification: null,
      imgsrc:
        'data:image/png;base64,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'
    };
  },
  created() {
    this.handleIsVerification();
    if (this.$route.query.redirect && this.$route.query.redirect != '') {
      this.redirect = this.$route.query.redirect;
    }
  },
  methods: {
    handleIsVerification() {
      this.$store
        .dispatch('IsVerification')
        .then(res => {
          console.log('res', res)
          if (res && res.code === '200') {
            console.log('data', res.data)
            this.isVerification = res.data;
          }
        })
        .catch(() => {
          console.log('错误');
        });
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    countDown() {
      if (!this.disabled) return; // 改动的是这两行代码
      this.disabled = false;
      this.content = this.totalTime + 's';
      const _th = this;
      const clock = window.setInterval(() => {
        _th.totalTime--;
        _th.content = _th.totalTime + 's';

        if (_th.totalTime < 0) {
          window.clearInterval(clock);
          _th.content = '发送验证码';
          _th.totalTime = 60;
          _th.disabled = true; // 这里重新开启
        }
      }, 1000);
    },

    handleImgSrc() {
      this.$store
        .dispatch('Verification', this.loginForm)
        .then(res => {
          this.imgsrc = res.data;
          this.loginForm.captcha_id = res.captcha_id;
        })
        .catch(() => {
          console.log('错误');
        });
    },

    handleRetrievePassword() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('RetrievePassword', this.loginForm)
            .then(res => {
              this.$message({
                message: res.msg_show,
                type: 'success'
              });
              this.loading = false;
              this.next = true;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log('参数验证不合法！');
          return false;
        }
      });
    },

    handleModifyPassword() {
      this.$refs.forgetForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('ModifyPassword', this.forgetForm)
            .then(res => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.loading = false;
              this.handleLogins();
            })
            .catch(err => {
              if (err) {
                this.loading = false;
              }
            });
        } else {
          console.log('参数验证不合法！');
          return false;
        }
      });
    },

    handleCaptcha_value() {
      this.$refs.numberValidateForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch('Sendsms', this.loginForm)
            .then(res => {
              this.$message({
                message: res.msg_show,
                type: 'success'
              });
              this.loading = false;
              this.dialogVisible = false;
              this.countDown();
            })
            .catch(() => {
              this.loading = false;
              this.handleImgSrc();
            });
        }
      });
    },

    handleLogins() {
      this.$router.push({ name: 'login' });
    },
    handleRegister() {
      this.$router.push({ name: 'register' });
    },
    dialogConfirm() {
      this.dialogVisible = false;
      setSupport(true);
      window.location.href = SupportUrl;
    },
    dialogCancel() {
      this.dialogVisible = false;
      setSupport(false);
    },
    handleVerification() {
      this.$refs.loginForm.validateField('phone_nbr', moneyError => {
        if (!moneyError) {
          if (!this.disabled) return; // 改动的是这两行代码
          this.handleImgSrc();
          this.dialogVisible = true;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "src/styles/publicSubmit.scss";
.forgetPassword {
  .loginForm .input-group .input-group-append .btn {
    height: 40px;
    border-radius: 0;
    width: 95px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/forgetPassword/index.vue